// tslint:disable: max-line-length no-unused-expression
import { FormControl, FormArray, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

import { REGEXP } from 'src/app/constants/reg-exp';

import { BooleanValues } from 'src/app/interfaces/undetermined';

@Injectable({ providedIn: 'root' })
export class SharedFunctionsService {

  // redirectToLogInPage(): Método que redirecciona a iniciar sesión
  redirectToLogInPage() {
    if (environment.production) {
      // ↓ elimina las propiedades del storage
      this.logOff();
      // ↓ Espera a que se eliminen las propiedades del storage
      setTimeout(() => {
        // ↓↓ Redirecciona a iniciar sesión
        const link: HTMLAnchorElement = document.createElement('a'); link.href = "https://garantiascomunitarias.com";
        document.body.appendChild(link); link.click(); link.remove();
      }, 0);
    } else { console.error("Redirección a https://garantiascomunitarias.com"); }
  }

  // logOff(): Método que elimina las propiedades del storage
  logOff() { ["dashboard", "entity", "nav", "user", "mods", "alerts"].forEach((elm: string) => window.localStorage.removeItem(elm)); }

  // updateTime(): Método que actualiza el tiempo de sesión del usuario
  updateTime() {
    ["dashboard", "entity", "nav", "user", "mods", "alerts"].forEach((elm: string) => {
      // ↓ Verifica si la propiedad está almacenada en storage
      if (localStorage.getItem(elm)) {
        // value: Guarda la propiedad del storage
        const value: { time: number } = JSON.parse(localStorage.getItem(elm));
        // ↓ Modifica el tiempo y la propiedad del storage
        value.time = new Date().getTime(); localStorage.setItem(elm, JSON.stringify(value));
      }
    });
  }

  // getObjectNotReferenced(): Método que devuelve un objeto nuevo sin referencias internas
  getObjectNotReferenced(object: object): object {
    // setObjectProperties(): Rompe la referencia de las propiedades de un objeto
    const setObjectProperties = (elmReferenced: object) => {
      // ↓ Objeto a retonar sin referencias
      const option = {} as any;
      // ↓ Itera las propiedades del objeto y rompe las referencias que pueda tener
      Object.keys(elmReferenced).forEach((elm: string) => {
        option[elm] = typeof elmReferenced[elm] !== "object" ? (Object.values({ bk: elmReferenced[elm] })[0]) : (Array.isArray(elmReferenced[elm]) ? ([...elmReferenced[elm]]) : (elmReferenced[elm] === null ? null : { ...setObjectProperties(elmReferenced[elm]) }));
      });
      // ↓ Dvuelve el objeto sin referencias
      return option;
    };
    // objectToReturn: Objeto a retornar sin referencias
    const objectToReturn: object = {} as object;
    // ↓ Itera las propiedades del objeto y rompe las referencias que pueda tener
    Object.keys(object).forEach((elm: string) => {
      objectToReturn[elm] = typeof object[elm] !== "object" ? (Object.values({ bk: object[elm] })[0]) : (Array.isArray(object[elm]) ? ([...object[elm]]) : (object[elm] === null ? null : { ...setObjectProperties(object[elm]) }));
    });
    // ↓ Dvuelve el objeto sin referencias
    return { ...objectToReturn };
  }

  /* toggleMaterializeComponents(): Método que abre/cierra una ventana emergente
    component: Componente de Materializecss
    selector: Identificador del modal
    action: Acción a realizar
  */
  toggleMaterializeComponents(component: string, selector: string, action: string) {
    // element: Referencia de elemento en la página
    const element: HTMLElement = document.querySelector(selector);
    // ↓ Verifica si el elemento, selector y action son correctos y se pueden utilizar desde materializecss
    element && M.hasOwnProperty(component) && M[component].getInstance(element) && (typeof M[component].getInstance(element)[action] === "function") ? M[component].getInstance(element)[action]() : null;
  }

  /* showAlert(): Método que notifica al usuario
    message: Información a notificar
    timeToShowMessage: Tiempo que durará en pantalla el toast cuando toda va bien
    timeToShowError: Tiempo que durará en pantalla el toast cuando algo sale mal
  */
  showAlert(message: string, timeToShowMessage = 60000, timeToShowError = 10000) {
    // ↓ Verifica si el navegador soporta las notificaciones
    if (!("Notification" in window)) {
      // ↓ Muestra mensaje
      M.toast({ html: message, classes: "background-success white-text", displayLength: timeToShowMessage });
    } else if (Notification.permission === "granted") {
      // ↑ Verifica si el usuario permite Notificaciones
      new Notification(message);
    } else if (Notification.permission !== "denied") {
      // ↑ Verifica si el usuario no ha saleecionado si permite o denega Notificaciones
      // ↓ Solicita permiso
      Notification.requestPermission().then((permission: string) => {
        // ↓ Verifica si el usuario permite Notificaciones
        permission === "granted" ? (new Notification(message)) : (M.toast({ html: message, classes: "background-success white-text", displayLength: timeToShowMessage }));
        // ↑ Muestra mensaje o notificación
      });
    } else { M.toast({ html: message, classes: "background-success white-text", displayLength: timeToShowMessage }); }
    // ↑ Muestra mensaje
  }

  /* checkTime() Método que verifica si un tiempo esta dentró de un rango determinado
    time: Hora a evaluar
    limit: Rango
  */
  checkTime(time: number, limit = 7200000): boolean {
    // now: Guarda la hora actual
    const now = new Date().getTime();
    // ↓ Es verdadero cuando la diferencia entre la hora enviada y la hora actual se encuentra dentro del rango enviado
    return Math.abs(now - (isNaN(time) ? 0 : (time === -1 ? now : time))) < limit;
  }

  /* validateTextarea(): Método para validar contenido de los textarea
    elm: Textarea a validar
  */
  validateTextarea(elm: FormControl): BooleanValues {
    // regex: Validación del campo
    const regex: RegExp = new RegExp(`^${REGEXP.text.slice(0, REGEXP.text.length - 7)}*$`, "igm");
    // ↓ Si pasa la validación permite, de lo contrario marca error
    return regex.test(elm.value.replace(/\n/g, "")) === false ? { res: true } : null;
  }

  /* validateRegExp(): Método para validar texto con una expresión regular
    value: Valor a comparar
    expression: expresión a utilizar
  */
  validateRegExp = (value: string, expression: string): boolean => new RegExp(`^${REGEXP[expression]}*$`, "igm").test(value);

  /* verifyControl(): Método que verifica la extensión de un archivo para formulario
    elm: contiene el nombre del archivo
  */
  verifyControl(elm: FormControl): BooleanValues {
    // ↓ Verifica que se haya adjuntado un archivo
    if (elm.value) {
      // ↓ Permite/denega el cargue del archivo
      return elm.value.toString().toLowerCase().substring(elm.value.length - 4) !== ".csv" ? { res: true } : null;
    }
  }

  /* isNumber(): Método que verifica si un valor es numérico
    elm: Valor a validar
  */
  isNumber = (elm: any): boolean => !isNaN(elm);

  /* setEntity(): Método que Añade entidades al formulario para validar
    data: Lista de entidades seleccionadas
    control: Formulario a añadir las entidades
  */
  setEntity(data: string[], control: any) {
    // ↓ Limpia el formulario
    (control as FormArray).clear();
    // ↓ Obtiene el nit de las entidades
    const entities: string[] = data.map((ent: string) => ent.split('(')[ent.split('(').length - 1].slice(0, -1));
    // ↓* Por cada uno añade al formulario
    (entities.length > 0 ? entities : ["0"]).forEach((elm: string) => {
      (control as FormArray).push(new FormControl(elm, [Validators.required, Validators.pattern(REGEXP.alphanumeric)]));
    });
  }

  /* generateHexString(): Método que gebera un id único
    length: Longitud del id
  */
  generateHexString(length: number): string {
    // ret: Guarda el id
    let ret = "";
    // ↓ Añade texto aleatorio
    while (ret.length < length) { ret += Math.random().toString(16).substring(2); }
    // ↓ Devuelve el id con la longitud indicada
    return ret.substring(0, length);
  }

  /* verifyBoolean() Método que verifica que la entrada de un formulario sea booleano
    elm: Valor ingresado en formulario
  */
  verifyBoolean(elm: FormControl): BooleanValues {
    // ↓ Si es un valor booleano permite, de lo contrario marca error
    return typeof elm.value !== "boolean" ? { res: true } : null;
  }

  /**
   * Calcula la variación de 2 valores
   * @param pv Valor anterior
   * @param cv Valor actual
   * @param base Base porcentual 100 o 1
   * @returns Valor de la variación
   */
  setPercentageVariation(pv: number, cv: number, base: 1 | 100 = 1): number {
    if (pv === undefined || cv === undefined) { return undefined; }
    if (pv === cv) { return 0; }
    if (pv === 0) { return (cv > 0 ? 1 : -1) * base; }
    if (cv === 0) { return (pv > 0 ? -1 : 1) * base; }
    if (pv > 0 && cv > 0) { return ((cv / pv) - 1) * base; }
    const log = Math.log(Math.abs(pv) / Math.abs(cv));
    return (log + ((1 / 2) * Math.pow(log, 2)) - ((1 / 3) * Math.pow(log, 3)) + ((1 / 4) * Math.pow(log, 4))) * base;
  }

}
